import {
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from '@mui/material'
import React from 'react'

const AccessSize = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Access Size</InputLabel>
      <Select
        value={moduleValues?.['Access Size'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Access Size']: e.target.value,
          }))
        }
        label="Access Size"
      >
        <ListSubheader>Intravenous</ListSubheader>
        <MenuItem value="14G">14G (Orange)</MenuItem>
        <MenuItem value="16G">16G (Grey)</MenuItem>
        <MenuItem value="18G">18G (Green)</MenuItem>
        <MenuItem value="20G">20G (Pink)</MenuItem>
        <MenuItem value="22G">22G (Blue)</MenuItem>
        <MenuItem value="24G">24G (Yellow)</MenuItem>
        <MenuItem value="26G">26G (Purple)</MenuItem>
        <ListSubheader>Intraosseous</ListSubheader>
        <MenuItem value="15mm">15mm (Pink)</MenuItem>
        <MenuItem value="25mm">25mm (Blue)</MenuItem>
        <MenuItem value="45mm">45mm (Yellow)</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default AccessSize
